import {
  requester
} from '../utils';

export const fetchAllDashbaordData = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/report/admin`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchAllCafeAdminDashbaordData = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/report/cafe-admin`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};